export default __webpack_public_path__ + "static/media/hvac_dashboard.923ed3ad.jpg";